import React from 'react';
import replaceCommaWithDot from '../../../../helpers/utils/replaceCommaWithDot';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model;

    return (
        <React.Fragment>
            <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER_NEW')}</div>
            <div className="main-result">
                <p className="monthly-payment">
                    {calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}
                </p>
                <p className="monthly-payment-value">
                    {replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} {calc.l10n('UAH_LOW_CASE')}{' '}
                    <span className="asterix">*</span>
                </p>
            </div>

            <div className={`loan-conditions`}>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_OVERPAYMENT_NEW')}</p>
                    <p>
                        {replaceCommaWithDot(model.getOverpayment().toLocaleString())} {calc.l10n('UAH_LOW_CASE')}
                    </p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW')}</p>
                    <p>
                        {model.getCreditSum().toLocaleString()} {calc.l10n('UAH_LOW_CASE')}
                    </p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">
                        {calc.l10n('CALCULATOR_CREDIT_INSTALLMENT_MONTH_COMISSION_NEW')}
                    </p>
                    <p>
                        {replaceCommaWithDot(model.getMonthCommission())}
                        {calc.l10n('CALCULATOR_CREDIT_PERCENT')}
                    </p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_TOTAL_COST_NEW')}</p>
                    <p>
                        {replaceCommaWithDot(model.getCreditCost().toLocaleString())} {calc.l10n('UAH_LOW_CASE')}
                    </p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE_NEW')}</p>
                    <p>{model.getRealInterestRate()}%</p>
                </div>
                <div className="loan-conditions-item">
                    <p className="condition-text">{calc.l10n('CALCULATOR_CREDIT_FORM_NEW')}</p>
                    <p>
                        {model.getCreditTerm()} {calc.l10n('CALCULATOR_MONTHS')}
                    </p>
                </div>
            </div>
            <div className="line" />
        </React.Fragment>
    );
}
